// extracted by mini-css-extract-plugin
module.exports = {"root":"Utilization_root__3NYed","overutilized":"Utilization_overutilized__hVEIn"};